import React from 'react';
import { Award } from 'lucide-react';

const AchievementBadge = ({ orderCount }) => {
  // Determine badge level based on order count
  const getBadgeLevel = (count) => {
    if (count >= 1000) return 'gold';
    if (count >= 500) return 'silver';
    if (count >= 100) return 'bronze';
    return null;
  };

  // Get badge configuration
  const getBadgeConfig = (level) => {
    switch (level) {
      case 'gold':
        return {
          name: 'Oro',
          color: 'text-yellow-600 dark:text-yellow-400',
          bgColor: 'bg-yellow-50 dark:bg-yellow-900/20',
          borderColor: 'border-yellow-200 dark:border-yellow-800',
          iconColor: 'text-yellow-600 dark:text-yellow-400'
        };
      case 'silver':
        return {
          name: 'Plata',
          color: 'text-gray-600 dark:text-gray-400',
          bgColor: 'bg-gray-50 dark:bg-gray-900/20',
          borderColor: 'border-gray-300 dark:border-gray-700',
          iconColor: 'text-gray-600 dark:text-gray-400'
        };
      case 'bronze':
        return {
          name: 'Bronce',
          color: 'text-amber-700 dark:text-amber-400',
          bgColor: 'bg-amber-50 dark:bg-amber-900/20',
          borderColor: 'border-amber-200 dark:border-amber-800',
          iconColor: 'text-amber-700 dark:text-amber-400'
        };
      default:
        return null;
    }
  };

  const badgeLevel = getBadgeLevel(orderCount);
  
  // Don't show badge if less than 100 orders
  if (!badgeLevel) {
    return null;
  }

  const config = getBadgeConfig(badgeLevel);

  return (
    <div className={`inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium border ${config.bgColor} ${config.borderColor} ${config.color}`}>
      <Award className={`h-4 w-4 mr-1.5 ${config.iconColor}`} />
      <span className="font-semibold">{config.name}</span>
      <span className="ml-1.5 text-xs opacity-75">
        {orderCount} órdenes
      </span>
    </div>
  );
};

export default AchievementBadge;